import {MenuItem, styled, Table, TableCell, TableContainer, TableRow} from "@mui/material";

export const OrderListContainer = styled(TableContainer)(() => ({

}));

export const OrderTable = styled(Table)(() => ({
    overflow: 'auto',

    '& .MuiTableRow-root:hover': {
        backgroundColor: '#f9f9fc'
    },
}));

export const OrderTableRow = styled(TableRow)(({theme}) => ({
    cursor: 'pointer',
    backgroundColor: '#fff',
    borderBottom: `2px solid ${theme.barekam.background}`,
}));

export const OrderTableCell = styled(TableCell)(() => ({
    padding: '0.2rem 1rem',
}));

export const ClickableColumnContainer = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',

    '& span': {
        color: theme.barekam.blue
    }
}));

export const OrderListActionItem = styled(MenuItem)(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '0.5rem',
    '& img': {
        filter: 'brightness(1000%) saturate(0%) contrast(0%)'
    }
}))